import React from 'react';
import {motion} from 'framer-motion';

const Hero=()=> {
  const scrollToReferences=()=> {
    document.getElementById('references')?.scrollIntoView({behavior: 'smooth'});
  };

  const scrollToContact=()=> {
    document.getElementById('contact-section')?.scrollIntoView({behavior: 'smooth'});
  };

  return (
    <section className="relative pt-32 pb-20 lg:pt-48 lg:pb-32 overflow-hidden">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-blue-600/20 rounded-full blur-[120px] pointer-events-none opacity-50" />
      <div className="absolute top-1/3 left-1/3 w-[600px] h-[600px] bg-purple-600/10 rounded-full blur-[100px] pointer-events-none opacity-50" />
      <div className="max-w-[1100px] mx-auto px-4 md:px-8 text-center relative z-10">
        <motion.p
          initial={{opacity: 0,y: 15}}
          animate={{opacity: 1,y: 0}}
          transition={{duration: 0.6,ease: "easeOut"}}
          className="text-xs md:text-sm text-blue-400 mb-3 font-medium tracking-wide"
        >
          Founded by Anish Malhotra
        </motion.p>
        <motion.h1
          initial={{opacity: 0,y: 15}}
          animate={{opacity: 1,y: 0}}
          transition={{duration: 0.6,ease: "easeOut"}}
          className="text-4xl md:text-6xl lg:text-7xl font-bold text-white tracking-tight leading-[1.1] mb-6"
        >
          Explore the Website Portfolio by{' '}
          <span className="text-gradient">BPA Solutions</span>
        </motion.h1>
        <motion.p
          initial={{opacity: 0,y: 15}}
          animate={{opacity: 1,y: 0}}
          transition={{duration: 0.6,delay: 0.1,ease: "easeOut"}}
          className="text-lg md:text-2xl text-slate-300 mb-6 leading-relaxed max-w-3xl mx-auto"
        >
          BPA Solutions builds premium website systems that work harmoniously to present your business professionally, capture enquiries and keep promoting your digital asset long after the first visit.
        </motion.p>
        <motion.p
          initial={{opacity: 0,y: 15}}
          animate={{opacity: 1,y: 0}}
          transition={{duration: 0.6,delay: 0.2,ease: "easeOut"}}
          className="text-sm md:text-base text-slate-400 mb-10 max-w-2xl mx-auto"
        >
          View website references across trades, local services, professional businesses, booking-based services and automation-led systems.
        </motion.p>
        <motion.div
          initial={{opacity: 0,y: 15}}
          animate={{opacity: 1,y: 0}}
          transition={{duration: 0.6,delay: 0.3,ease: "easeOut"}}
          className="flex flex-col sm:flex-row items-center justify-center gap-4"
        >
          <button
            onClick={scrollToReferences}
            className="w-full sm:w-auto px-8 py-3.5 bg-blue-600 hover:bg-blue-500 text-white rounded-full font-medium transition-colors shadow-[0_0_20px_rgba(37,99,235,0.3)]"
          >
            View Portfolio
          </button>
          <button
            onClick={scrollToContact}
            className="w-full sm:w-auto px-8 py-3.5 bg-white/5 hover:bg-white/10 border border-white/10 text-white rounded-full font-medium transition-colors"
          >
            Request Similar
          </button>
        </motion.div>
      </div>
    </section>
  );
};

export default Hero;